import React, { useState } from 'react';
import Pagination from '../pagination';
import MostraStatus from '../mostraStatus';
import { useFirestore } from '../../hooks/useFirestore';
import { useAlert } from '../../contexts/alerta';
import { useNavigate } from 'react-router-dom';
import MostraGravidade from '../mostraGravidade';
import { FaFileContract } from 'react-icons/fa';
import MostraMotivo from '../mostraMotivo';

export default function Tabela({ lista, callBack }) {
  const [itemsPorPagina, setItemsPorPagina] = useState(10)
  const [paginaAtual, setPaginaAtual] = useState(0)
  const { marcarComoLido } = useFirestore()
  const { addAlert } = useAlert()
  const nav = useNavigate()

  const paginas = Math.ceil(lista.length / itemsPorPagina)
  const startIndex = paginaAtual * itemsPorPagina
  const endIndex = startIndex + itemsPorPagina

  const currentItens = lista.slice(startIndex, endIndex)

  const handleSelectRelato = (rec) => {
    if (rec.lido === undefined || rec.lido === false) {
      marcarComoLido(rec)
        .then(rec => {
          nav('/relatos/relato',{state: {relato : rec}})
        })
        .catch(() => {
          addAlert('Um problema inesperado ocorreu!', "error")
        })
    } else {
      nav('/relatos/relato',{state: {relato : rec}})
    }
  }

  return (
    <div className="flex flex-col bg-white shadow rounded-lg">
      <div className='flex flex-row justify-between w-full gap-8 p-4'>
        <div className="">
          <select
            className='shadow rounded p-2 appearance-none mr-2 font-semibold text-secondary'
            name="itensPerPage"
            id="itensPerPage"
            onChange={(e) => setItemsPorPagina(Number(e.target.value))}>
            <option value={10}>10</option>
            <option value={15}>15</option>
            <option value={20}>20</option>
          </select>
          <span className='text-secondary'>Items por página</span>
        </div>
        {/* 
          <input type="text" placeholder='Pesquisar' className='p-2 rounded border-2 border-background outline-none' />
        */}
      </div>
      <table className=' w-full mt-4 mb-4'>
        <thead>
          <tr className='font-semibold uppercase bg-background '>
            <th className='px-4 py-2'>Protocolo</th>
            <th className='px-4 py-2'>Nome</th>
            <th className='px-4 py-2'>Motivo</th>
            <th className='px-4 py-2'>Status</th>
            <th ></th>
            <th ></th>
          </tr>
        </thead>
        <tbody>
          {currentItens.map((rec, i) => {
            return (
              <tr
                className={'text-secondary text-center border-b-background border-b-2 hover:bg-background hover:cursor-pointer ' + (rec.lido !== true ? 'bg-secondary bg-opacity-25 font-semibold' : '')}
                key={i}
                onClick={() => handleSelectRelato(rec)}
              >
                <td className='py-4'>{rec.uuid}</td>
                <td >{rec.nome ? rec.nome : "Anônimo"}</td>
                <td ><MostraMotivo motivo={rec.motivo} lang={'pt'}/></td>
                <td ><MostraStatus status={rec.status} lang={'ptbr'}/></td>
                <td ><MostraGravidade gravidade={rec.gravidade} /></td>
                <td >
                  {
                    rec.procedencia ? 
                      <FaFileContract className='text-primary h-4 w-4' title='Procedente'/>
                    :
                      <FaFileContract className='text-background h-4 w-4' title='Não Procedente'/>
                  }
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
      <div className='flex flex-row justify-end p-4 w-full gap-8'>
        <Pagination currentPage={paginaAtual} setCurrentPage={setPaginaAtual} pages={paginas} />
      </div>
    </div>
  )
};
